module.exports = __webpack_public_path__ + "img/step-8.17bbbf81.jpg";